import { Box, Grid } from '@chakra-ui/react'
import { FC } from 'react'
import ReactApexChart from 'react-apexcharts'

import LayoutEmpty from '@component/Layout/Empty'

import { IGraphicResponse } from '@base/@types/providers/Otb/FollowUpProvider'

import {
  getStorageSeries,
  storageOptions
} from './ParseInfos/parseFollowUpChartInfos'

interface IOtbFollowUpGraphicProps {
  data: IGraphicResponse
}

const OtbFollowUpGraphic: FC<IOtbFollowUpGraphicProps> = ({ data }) => {
  return (
    <Box borderTop="1px solid #e3e3e3">
      <Grid background="gray.100" paddingTop={4}>
        {data.desvioMedio.length === 0 ? (
          <Box height={250}>
            <LayoutEmpty
              type="chartEmpty"
              title="Nada encontrado!"
              message="Filtre sua busca ao lado para obter informações"
            />
          </Box>
        ) : (
          <Box paddingLeft={2}>
            <ReactApexChart
              options={storageOptions(data)}
              series={getStorageSeries(data)}
              width="100%"
              type="bar"
              title="Estoque Open-To-By"
              height="250px"
            />
          </Box>
        )}
      </Grid>
    </Box>
  )
}

export default OtbFollowUpGraphic
